<button class="tableSortingButton">
    <fa-icon [icon]="changeIcon()"></fa-icon>
    <ng-content></ng-content>
</button>
